import { render, staticRenderFns } from "./buildGarbageClear.vue?vue&type=template&id=5e6782a2&scoped=true&"
import script from "./buildGarbageClear.vue?vue&type=script&lang=js&"
export * from "./buildGarbageClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6782a2",
  null
  
)

export default component.exports